import { Inviter, SessionState, UserAgent } from 'sip.js';
import APIManager from '../../modules/common/apiManager';

const io = require('socket.io-client');
const mAPI = new APIManager();

let instance = null;
let eventList = [
  'connect_error',
  'connect_timeout',
  'reconnect',
  'disconnect',
  'reconnect_attempt',
  'reconnecting',
  'reconnect_error',
  'reconnect_failed',
  'connect'
];
class SocketIO {
  constructor(config) {
    if (instance) {
      // return instance;
      if (config.url != instance.config.url) {
        instance.destroy();
        instance = null;
      } else {
        return instance;
      }
    }
    this.socketConnected = false;
    this.config = config;
    this.connected = false;
    this.timeTry = 0;
    this.timeOut = '';
    this.socket = '';
    this.subscriberList = {};
    this.sipConfig = {};

    if (config.sipConfig) {
      let sipConfig = config.sipConfig;
      this.sipConfig = {
        authorizationUsername: sipConfig.username,
        authorizationPassword: sipConfig.password,
        displayName: sipConfig.username,
        contactName: sipConfig.username,
        userAgentString: '',
        traceSip: false,
        register: true,
        uri: UserAgent.makeURI(`sip:${sipConfig.username}@${sipConfig.domain}`),
        transportOptions: {
          server: sipConfig.url
        },
        password: sipConfig.password
      };
    }
    this.startSocketIO();

    this.options = {
      media: {
        constraints: {
          audio: true,
          video: false
        }
      }
    };
    instance = this;
  }

  async startSocketIO() {
    try {
      const getTicket = () => new Promise((resolve, reject) => {
        mAPI.sendPostAPI(
          'auth/socket-ticket',
          {}, // Empty data payload
          (data) => resolve(data),
          (error) => reject(error),
          "private"
        );
      });

      let socketToken = '';
      try {
        const response = await getTicket();
        console.log("Ticket Response :", response);
        if (response && response.data && response.data.ticket) {
          socketToken = response.data.ticket;
        } 
      } catch (err) {
        console.error("Failed to get socket ticket", err);
      }

      let queryParams = this.config.query || {};
      if (socketToken) {
        queryParams.token = socketToken;
      }
      const tenant = localStorage.getItem('selected-tenant');
      if (tenant) {
        queryParams.tenant = tenant;
      }

      this.socket = io(this.config.url, {
        reconnection: false,
        reconnectionAttempts: 'inifinity',
        reconnectionDelay: 1000,
        reconnectionDelayMax: 3000,
        randomizationFactor: 0.5,
        timeout: 20000,
        autoConnect: true,
        path: this.config.path || '/socket.io',
        query: queryParams,
        transports: ['websocket'],
        rejectUnauthorized: false
      });
      this.subscribleAndConnect();
      // sip.initPhone(this.sipConfig);
    } catch (e) {
      console.log(e);
    }
  }

  apDialerStatus(status) {
  }

  getTimeout() {
    let connectionTimeOut = 1000;
    if (this.timeTry > 1800) {
      connectionTimeOut = 5000;
    } else if (this.timeTry > 1200) {
      connectionTimeOut = 4000;
    } else if (this.timeTry > 600) {
      connectionTimeOut = 3000;
    } else if (this.timeTry > 300) {
      connectionTimeOut = 2000;
    }
    return connectionTimeOut;
  }
  retryManualLogic() {
    clearTimeout(this.timeOut);
    var _this = this;
    let connectionTimeOut = this.getTimeout();
    this.timeTry++;

    this.timeOut = setTimeout(function() {
      _this.destroy();
      _this.startSocketIO();
    }, connectionTimeOut);
  }

  removeEvent(event) {
    if (eventList.indexOf(event) == -1) {
      // if(this.subscriberList[event]){
        this.socket.off(event);
      // }
    }
  }
  subscriber(event, cb) {
    this.subscriberList[event] = cb;
    if (this.socket) {
      this.removeEvent(event);
      // this.socket.on(event, cb);
      this.socket.on(event, this.subscriberList[event]);
    }
  }
  subscribleAndConnect() {
    var _this = this;
    this.socket.on('connect_error', error => {
      _this.retryManualLogic();
    });
    this.socket.on('connect_timeout', () => {
      _this.retryManualLogic();
    });
    this.socket.on('reconnect', attempt => {
      _this.retryManualLogic();
    });
    this.socket.on('disconnect', attempt => {
      _this.retryManualLogic();
    });
    this.socket.on('reconnect_attempt', error => {
      // _this.retryManualLogic();scrollBehavior:
    });
    this.socket.on('reconnecting', attempt => {
      // _this.retryManualLogic();
    });
    this.socket.on('reconnect_error', error => {
      // _this.retryManualLogic();
    });
    this.socket.on('reconnect_failed', () => {
      // _this.retryManualLogic();
    });
    this.socket.on('connect', function() {
      _this.timeTry = 0;
      _this.connected = true;
    });
    for (const event in this.subscriberList) {
      if (Object.hasOwnProperty.call(this.subscriberList, event)) {
        if (typeof this.subscriberList[event] == `function`) {
          this.removeEvent(event);
          this.socket.on(event, this.subscriberList[event]);
        }
      }
    }
  }
  emit(type, messageData) {
    if (this.socket && this.socket.emit) {
      this.socket.emit(type, messageData);
    }
  }
  destroy() {
    try {
      if (this.socket) {
        this.socket.off('disconnect');
        this.socket.disconnect();
        this.socket.destroy();
        this.socket = null;
      }
    } catch (ex) {
    }
  }
}

export default SocketIO;



// WEBPACK FOOTER //
// src/dialpad/service/socket.transport.js